import React, { useEffect, useState, useCallback } from "react";
import {
  MdOutlineLocationOn,
  MdOutlineMail,
  MdOutlinePhone,
  MdOutlineDateRange,
  MdInfoOutline,
  MdBookmark,
} from "react-icons/md";
import { AiOutlineFileText } from "react-icons/ai";
import { CandidateButtons } from "./ReportOverview";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import constantVariables, { mails } from "../../helpers/constantVariables";
import MailPopup from "./MailPopup";
import { HireDropDown1 } from "../reusble_components/buttons/HireDropDown";
import { MdBookmarkBorder } from "react-icons/md";
import ApplicantLabelPopup from "./Resume/applicant_labelPopup";
import { pdfjs } from "react-pdf";
import { toJS } from "mobx";
import axios from "axios";
import Loader from "../reusble_components/loader";
import { ProgressBarTracker } from "../reusble_components/profileProgress";
import { IoIosArrowDropright } from "react-icons/io";
import Remainder from "../reusble_components/popup/Remainder";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import ProxyReasonDialog from "./ProxyReasonDialog";
import { getUserDetailsFromLocalStorage } from "../../services/reusable";

export default function Applicant({
  candidate,
  recruiter,
  reportData,
  enable,
  isJobPost = true,
}) {
  return useObserver(() => (
    <div className="w-full">
      <div className="w-full  mx-auto">
        <CandidateCard
          isJobPost={isJobPost}
          enable={enable}
          candidate={candidate}
          recruiter={recruiter}
          reportData={reportData}
        />
      </div>
      {/* Other components go here */}
    </div>
  ));
}

export function CandidateCard({
  candidate,
  recruiter,
  reportData,
  enable,
  isJobPost = true,
}) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  const { RecuiterStore, PopupStore, LabelStore, CommonStore, InterviewStore } =
    useStores();
  const [content, setContent] = useState("");
  const [sub, setSub] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [loader, setLoader] = useState(false);
  const [progressData, setProgressData] = useState(null);
  const [accessTypeStatus, setAccessTypeStatus] = useState("unrestricted");
  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data;
      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      return fullText; // Return fullText from the function
    } catch (error) {
      if (error.response && error.response.status === 404) {
        alert("The PDF file was not found (404). Please check the file URL.");
      } else {
        console.error("Error fetching or parsing PDF file", error);
      }
      return null; // Return null in case of an error
    }
  };
  const getProgress = async () => {
    const progress = await RecuiterStore.getApplicantProgress(candidate.id);
  };

  //Access Type
  const accessType = async () => {
    const user = await getUserDetailsFromLocalStorage();
    console.log(user, "user");
    if (user?.access) {
      console.log(user?.access[0]?.accessType, "user?.access[0]?.accessType");
      const status =
        user?.access[0]?.accessType === "6971bb50ce17d9413a277db4"
          ? "restricted"
          : "unrestricted";
      console.log(status, "status11");
      return status;
    }
    return "unrestricted";
  };

  useEffect(() => {
    const fetchAccessType = async () => {
      const access = await accessType();
      console.log(access, "access");
      setAccessTypeStatus(access);
    };
    fetchAccessType();
  }, []);

  useEffect(() => {
    getProgress();
    // console.log(RecuiterStore.applicantProgres, "progress");
    setProgressData(RecuiterStore.applicantProgres);
  }, [RecuiterStore.jobPostApplicant]);
  const GenerateResumeScore = async (resume) => {
    console.log("GenerateResumeScore");
    console.log(loader);
    console.log("this is Resume", candidate?.resume);

    // alert(isJobPost);

    // console.log("this is Resume", candidate?.resume);

    const resumeText1 = await fetchData(resume);
    console.log(resume, "resumeText1");
    const resumeText = isJobPost ? resumeText1 : candidate?.resume;
    console.log(resumeText1, "resumeText");

    if (!resumeText) {
      alert(
        "The resume Uploaded by the candidate is not in a readable format. ",
      );
      setLoader(false);
      return;
    }

    RecuiterStore.fetchResumeScoreAPI(candidate.id, resumeText).then(() => {
      console.log(loader);
      RecuiterStore.fetchApplicantDetails(candidate.id);
      setLoader(false);
      console.log(loader);
    });
  };

  const message = `

Dear ${candidate.name},

We are pleased to inform you that you have been shortlisted for the ${
    candidate.jobRole
  } at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. After reviewing your application and assessment results, we are impressed by your qualifications and experience.

What's Next:
Our recruitment team will reach out to you shortly with further details on the next steps. This may include a phone interview, an in-person interview, or additional assessments, depending on the role.
If you have any questions or need further information, please feel free to contact us at ${
    JSON.parse(localStorage.getItem("user"))?.mail
  } or call us at ${JSON.parse(localStorage.getItem("user"))?.mobile}.
Thank you once again for your interest in joining ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. We are excited to move forward in the process and look forward to connecting with you soon.

Best regards,

${JSON.parse(localStorage.getItem("user"))?.name}
${
  JSON.parse(localStorage.getItem("user"))?.designation
    ? JSON.parse(localStorage.getItem("user"))?.designation
    : "[Your Designation]"
}
${JSON.parse(localStorage.getItem("user"))?.companyName}


`;
  const Hiredmessage = `
  Dear ${candidate.name},

  We are thrilled to inform you that you have been selected for the ${
    candidate.jobRole
  } position at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. Your skills and experience are a perfect match for our team.

  Next Steps:
  Our HR team will contact you soon to discuss the onboarding process and other formalities. Please keep an eye on your email and phone for further instructions.

  If you have any questions, feel free to reach out to us at ${
    JSON.parse(localStorage.getItem("user"))?.mail
  } or ${JSON.parse(localStorage.getItem("user"))?.mobile}.

  Congratulations once again, and welcome to ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }!

  Best regards,

  ${JSON.parse(localStorage.getItem("user"))?.name}
  ${
    JSON.parse(localStorage.getItem("user"))?.designation
      ? JSON.parse(localStorage.getItem("user"))?.designation
      : "[Your Designation]"
  }
  ${JSON.parse(localStorage.getItem("user"))?.companyName}

`;
  const Hiredsubject = `Congratulations! You've Been Hired for ${
    candidate.jobRole
  } at ${JSON.parse(localStorage.getItem("user"))?.companyName}!`;

  const subject = `Congratulations! You've Been Shortlisted for ${
    candidate.jobRole
  } at ${JSON.parse(localStorage.getItem("user"))?.companyName}!`;
  const Rejectsubject = `Update on Your Application for ${
    candidate.jobRole
  } at ${JSON.parse(localStorage.getItem("user"))?.companyName}`;

  const Rejectmessage = `
  Dear ${candidate.name},

  Thank you for your interest in the ${candidate.jobRole} at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. After careful consideration, we regret to inform you that we will not be moving forward with your application at this time.

  We appreciate the effort you put into the application and assessment process. While we won't be progressing with your candidacy for this role, we were impressed by your qualifications and encourage you to apply for future opportunities that may align with your skills and experience.

  Thank you once again for considering a career with ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. We wish you the best in your job search and future endeavors.

  Best regards,

  ${JSON.parse(localStorage.getItem("user"))?.name}
  ${
    JSON.parse(localStorage.getItem("user"))?.designation
      ? JSON.parse(localStorage.getItem("user"))?.designation
      : "[Your Designation]"
  }
  ${JSON.parse(localStorage.getItem("user"))?.companyName}
`;
  const updateCandidateStatus = (status) => {
    if (status) {
      setStatusNumber(1);
    } else {
      setStatusNumber(2);
    }
    console.log(toJS(status));
    setStatus(status);
    setStatusCondition("Shortlist");
    // RecuiterStore.ChangeApplicantStatus(status);
  };
  const HireCandidate = (status) => {
    console.log(toJS(status));
    // RecuiterStore.HireApplicant(status);
    setStatusNumber(3);
    setStatusCondition("Hire");

    setStatus(status);
  };

  const ProxyCandidate = (status) => {
    console.log(toJS(status));
    // RecuiterStore.HireApplicant(status);
    setStatusNumber(4);
    setStatusCondition("Proxy");

    setStatus(status);
  };

  const handleProxyReasonSelect = async (reasonsArray) => {
    // Store selected proxy reasons
    setSelectedProxyReasons(reasonsArray);

    // Save proxy reasons to candidate
    if (candidate?.id || candidate?._id) {
      const candidateId = candidate?.id || candidate?._id;
      await RecuiterStore.updateApplicantProxyReasons(
        candidateId,
        reasonsArray,
      );
      // Refresh candidate details to get updated proxy reasons
      await RecuiterStore.fetchApplicantDetails(candidateId);
    }

    // Format proxy reasons as a numbered list
    const reasonsList = reasonsArray
      .map((reason, index) => `${index + 1}. ${reason}`)
      .join("\n");

    // Get subject from template
    const subject = getSub(mails["proxy"].subject, {
      _Position_: candidate?.jobRole,
      _Company_Name_: JSON.parse(localStorage.getItem("user"))?.companyName,
    });

    // Get body from template and replace proxy reasons placeholder
    let emailBody = getSub(mails["proxy"].body, {
      _Position_: candidate?.jobRole,
      _Company_Name_: JSON.parse(localStorage.getItem("user"))?.companyName,
      _recruiter_email_: JSON.parse(localStorage.getItem("user"))?.mail,
      _contact_number_: JSON.parse(localStorage.getItem("user"))?.mobile,
      _Name_: JSON.parse(localStorage.getItem("user"))?.name,
      _your_Position_:
        JSON.parse(localStorage.getItem("user"))?.designation ||
        "[Your Designation]",
      _Proxy_Reasons_: reasonsList,
    });

    // Convert newlines in body to actual line breaks
    emailBody = emailBody.replace(/\\n/g, "\n");

    setSub(subject);
    setContent(emailBody);
    setMail(true);
    PopupStore.setMail(true);
  };

  const HOLDCandidate = (status) => {
    console.log(toJS(status));
    // RecuiterStore.HireApplicant(status);
    setStatusNumber(0);
    setStatusCondition("Hold");

    setStatus(status);
  };

  const [status, setStatus] = useState(null);

  const [statusCondition, setStatusCondition] = useState(null);
  const [statusNumber, setStatusNumber] = useState(0);
  const [mail, setMail] = useState(false);
  const [timer, setTimer] = useState();
  const [proxyDialogOpen, setProxyDialogOpen] = useState(false);
  const [selectedProxyReasons, setSelectedProxyReasons] = useState([]);
  function getSub(template, variables) {
    // Replace placeholders in subject and body with variable values

    const filledSubject = template.replace(
      /\[([^\]]+)\]/g,
      (_, key) => variables[key] || `[${key}]`,
    );

    return filledSubject;
  }

  const [skillsCount, setSkillsCount] = useState(4);

  const convertTimestampToDate = (timestamp) => {
    if (!timestamp) return null;
    const date = new Date(timestamp);

    // Function to get the month name
    const getMonthName = (monthIndex) => {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      return months[monthIndex];
    };

    // Format the date to 'Month day, year, time' format
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    const formattedDate = `${getMonthName(
      date.getMonth(),
    )} ${date.getDate()}, ${date.getFullYear()} ${formattedHours}:${formattedMinutes} ${ampm}`;

    return formattedDate;
  };

  const getDate = (timestamp) => {
    if (!timestamp) return null;
    const date = new Date(timestamp);
    return date.toLocaleDateString();
  };

  const findProgressItem = (label) => {
    return RecuiterStore.applicantProgres?.find((item) => item.label === label);
  };

  const getProgressItemCompleted = (label, fallbackData = null) => {
    const item = findProgressItem(label);
    if (item?.isCompleted) {
      return item.score > (item.cutOff || 0);
    }
    return fallbackData?.isCompleted || false;
  };

  const getProgressItemDate = (label) => {
    const item = findProgressItem(label);
    return item?.createdAt ? convertTimestampToDate(item.createdAt) : null;
  };

  const isProgressItemRejected = (label) => {
    const item = findProgressItem(label);
    if (item?.isCompleted) {
      return item.score < (item.cutOff || 0);
    }
    return false;
  };

  const getSteps = () => {
    const steps = [];

    // Step 1: Applied (default first step)
    steps.push({
      label: "Applied",
      completed: true,
      label2: "Applied",
      date: candidate?.date,
      show: true,
      rejected: false,
    });

    // Step 2: Resume Cutoff (if available)
    const resumeItem = findProgressItem("resume");
    if (resumeItem || candidate?.resumeScore) {
      steps.push({
        label: "Resume",
        completed: candidate?.resumeScore > 50,
        label2: "Resume",
        date: candidate?.date,
        show: true,
        rejected: candidate?.resumeScore <= 50,
        reson: candidate?.resumeScore
          ? `Resume Score: ${candidate?.resumeScore}%`
          : "Resume not scored",
      });
    }

    // Step 3: MCQ's (if available in job post)
    if (reportData && reportData[1]?.show) {
      const mcqItem = findProgressItem("mockTest");
      steps.push({
        label: "MCQ's",
        completed: getProgressItemCompleted("mockTest", reportData[1]),
        label2: "MCQ's",
        date: getProgressItemDate("mockTest"),
        show: true,
        rejected: isProgressItemRejected("mockTest"),
        reson: mcqItem?.isCompleted
          ? mcqItem.score >= (mcqItem.cutOff || 0)
            ? "Candidate passed MCQ cutoff"
            : "Candidate did not meet MCQ cutoff"
          : "Candidate did not attempt MCQ",
      });
    }

    // Step 4: Technical Interview (if available)
    if (reportData && reportData[2]?.show) {
      const techItem = findProgressItem("technicalInterview");
      steps.push({
        label: "Technical Interview",
        completed: getProgressItemCompleted(
          "technicalInterview",
          reportData[2],
        ),
        label2: "Technical Interview",
        date: getProgressItemDate("technicalInterview"),
        show: true,
        rejected: isProgressItemRejected("technicalInterview"),
        reson: techItem?.isCompleted
          ? techItem.score >= (techItem.cutOff || 0)
            ? "Candidate passed Technical cutoff"
            : "Candidate did not meet Technical cutoff"
          : "Candidate did not attempt Technical Interview",
      });
    }

    // Step 5: HR Interview (if available)
    if (reportData && reportData[3]?.show) {
      const hrItem = findProgressItem("hrInterview");
      steps.push({
        label: "HR Interview",
        completed: hrItem?.isCompleted || reportData[3]?.isCompleted || false,
        label2: "HR Interview",
        date: getProgressItemDate("hrInterview"),
        show: true,
        rejected: isProgressItemRejected("hrInterview"),
        reson: hrItem?.isCompleted
          ? hrItem.score >= (hrItem.cutOff || 0)
            ? "Candidate passed HR cutoff"
            : "Candidate did not meet HR cutoff"
          : "Candidate did not attempt HR Interview",
      });
    }

    // Step 6: Task/Assessment (if available)
    if (
      RecuiterStore.applicantProgres?.find(
        (item) => item.label === "assessment",
      )
    ) {
      const assessmentItem = findProgressItem("assessment");
      steps.push({
        label: "Task",
        completed: assessmentItem?.isCompleted || false,
        label2: "Task",
        date: getProgressItemDate("assessment"),
        show: true,
        rejected: false,
        reson: assessmentItem?.isCompleted
          ? "Candidate completed task"
          : "Candidate did not attempt task",
      });
    }

    // Step 7: Coding Interview (if available)
    if (
      RecuiterStore.applicantProgres?.find(
        (item) => item.label === "codingInterview",
      )
    ) {
      const codingItem = findProgressItem("codingInterview");
      steps.push({
        label: "Coding Interview",
        completed: codingItem?.isCompleted || false,
        label2: "Coding Interview",
        date: getProgressItemDate("codingInterview"),
        show: true,
        rejected: isProgressItemRejected("codingInterview"),
        reson: codingItem?.isCompleted
          ? codingItem.score >= (codingItem.cutOff || 0)
            ? "Candidate passed Coding Interview"
            : "Candidate did not meet Coding Interview cutoff"
          : "Candidate did not attempt Coding Interview",
      });
    }

    // Step 8: Final Status (Proxy, Reject, Hold, Shortlisted, Hired)
    let statusFound = false;
    const mailDetails =
      RecuiterStore.applicantProgres?.filter(
        (item) => item.label === "mailDetails",
      ) || [];

    // Check for explicit status from mail details
    for (const mail of mailDetails) {
      if (
        mail.purpose === "proxy" ||
        mail.purpose === "reject" ||
        mail.purpose === "rejected" ||
        mail.purpose === "shortlist" ||
        mail.purpose === "shortlisted" ||
        mail.purpose === "hold" ||
        mail.purpose === "hired"
      ) {
        const purpose = mail.purpose === "rejected" ? "reject" : mail.purpose;
        const statusLabel =
          purpose === "reject"
            ? "Rejected"
            : purpose === "shortlist" || purpose === "shortlisted"
              ? "Shortlisted"
              : purpose === "hold"
                ? "Hold"
                : purpose === "hired"
                  ? "Hired"
                  : purpose === "proxy"
                    ? "Proxy"
                    : "Unknown";

        steps.push({
          label: statusLabel,
          label2: statusLabel,
          completed: true,
          show: true,
          rejected: purpose === "reject",
          proxy: purpose === "proxy",
          hold: purpose === "hold",
          shortlisted: purpose === "shortlist" || purpose === "shortlisted",
          hired: purpose === "hired",
          date: convertTimestampToDate(mail.createdAt),
          popup: true,
          purpose: mail.purpose,
          subject: mail.subject,
          body: mail.content,
          toolTip: `Status: ${statusLabel}`,
        });
        statusFound = true;
        break;
      }
    }

    // If no status found in mail details, use candidate status
    if (!statusFound && candidate?.status !== undefined) {
      const statusMap = {
        0: { label: "Hold", color: "hold" },
        1: { label: "Shortlisted", color: "shortlisted" },
        2: { label: "Rejected", color: "reject" },
        3: { label: "Hired", color: "hired" },
        4: { label: "Proxy", color: "proxy" },
      };

      const status = statusMap[candidate.status];
      if (status) {
        steps.push({
          label: status.label,
          label2: status.label,
          completed: true,
          show: true,
          rejected: status.color === "reject",
          proxy: status.color === "proxy",
          hold: status.color === "hold",
          shortlisted: status.color === "shortlisted",
          hired: status.color === "hired",
          date: candidate?.date || null,
          toolTip: `Status: ${status.label}`,
        });
      }
    }

    return normalizeSteps(steps);
  };

  const normalizeSteps = (rawSteps) => {
    return rawSteps.map((step) => {
      const statusColorMap = {
        Rejected: { rejected: true, statusColor: "red" },
        Proxy: { proxy: true, statusColor: "yellow" },
        Hold: { hold: true, statusColor: "yellow" },
        Shortlisted: { shortlisted: true, statusColor: "green" },
        Hired: { hired: true, statusColor: "green" },
      };

      const statusInfo = statusColorMap[step.label] || {};

      const baseStep = {
        id: step.label,
        show: step.show !== false,
        passed:
          step.completed &&
          !step.reject &&
          !step.rejected &&
          !statusInfo.rejected,
        rejected: step.reject || step.rejected || statusInfo.rejected || false,
        proxy: step.proxy || statusInfo.proxy || false,
        hold: step.hold || statusInfo.hold || false,
        shortlisted: step.shortlisted || statusInfo.shortlisted || false,
        hired: step.hired || statusInfo.hired || false,
        ...step,
      };

      // Add rendering metadata based on step type
      switch (step.label) {
        case "resumeCutOff":
          return {
            ...baseStep,
            displayLabel: `${step.applicantResumeScore}%/${step.cutOff}%`,
            displayLabelShort: "Resume",
            tooltip: `Resume Cutoff\nScore: ${step.applicantResumeScore}% | Cutoff: ${step.cutOff}%\nStatus: ${step.applicantResumeScore >= step.cutOff ? "✓ Passed" : "✗ Failed"}`,
          };
        case "Rejected":
        case "Proxy":
        case "Hold":
        case "Shortlisted":
        case "Hired":
          return {
            ...baseStep,
            displayLabel: step.label,
            displayLabelShort: step.label,
            tooltip: step.toolTip || `Status: ${step.label}`,
            statusColor: statusInfo.statusColor,
          };
        default:
          return {
            ...baseStep,
            displayLabel: step.label2 || step.label,
            displayLabelShort: step.label2 || step.label,
            tooltip:
              step.toolTip ||
              `Status: ${baseStep.passed ? "Completed" : baseStep.rejected ? "Rejected" : "Pending"}`,
          };
      }
    });
  };

  const notifyMail = (
    <span
      className="cursor-pointer border border-primary p-1 bg-white hover:opacity-100 opacity-75 text-black rounded-md "
      onClick={() => {
        setMail(true);
        setSub(subject);
        setContent(message);
        PopupStore.setMail(true);
      }}
    >
      <MdOutlineMail />
    </span>
  );

  const subject1 = `Action Required: Start Your Assessment for ${
    candidate?.jobRole ? candidate?.jobRole : "[the position]"
  } `;
  const message1 = `
  Dear ${candidate?.name},

  Thank you for applying for the ${
    candidate?.jobRole ? candidate?.jobRole : "[the position]"
  } at ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  }. We noticed that you have not yet started the required assessment, which is an essential part of the application process.

  To proceed with your application, please follow the steps below to begin your assessment:
      Next Steps:
        1.Go to https://user.reaidy.io/.
        2.Navigate to the Activities section.
        3.Select the ${
          candidate?.jobRole ? candidate?.jobRole : "[the position]"
        } you applied for.
        4.Start your Assessment.

  Please make sure to begin the assessment by ${new Date().toLocaleDateString()} to continue being considered for the position.

  If you need any assistance or have questions, feel free to reach out to us at ${
    JSON.parse(localStorage.getItem("user"))?.mail
  } or contact us at ${JSON.parse(localStorage.getItem("user"))?.mobile}.

  We appreciate your interest in joining ${
    JSON.parse(localStorage.getItem("user"))?.companyName
  } and look forward to seeing your completed assessment.

  Best regards,

  ${JSON.parse(localStorage.getItem("user"))?.name}
  ${
    JSON.parse(localStorage.getItem("user"))?.designation
      ? JSON.parse(localStorage.getItem("user"))?.designation
      : "[Your Designation]"
  }
  ${JSON.parse(localStorage.getItem("user"))?.companyName}
  `;
  function generateAssessmentMessage(assessments) {
    const user = JSON.parse(localStorage.getItem("user"));

    const assessmentLinks = assessments
      .map(
        (assessment, index) =>
          `        ${index + 1}. ${assessment.name}: ${assessment.link}`,
      )
      .join("\n");

    return `
  Dear ${candidate?.name},

  Thank you for applying for the ${
    candidate?.jobRole ? candidate?.jobRole : "[the position]"
  } at ${
    user?.companyName ? user?.companyName : "[Company Name]"
  }. We noticed that you have not yet started the required assessment(s), which are an essential part of the application process.

  To proceed with your application, please follow the steps below to begin your assessment(s):

    Next Steps:

      Assessments:
${assessmentLinks}

------ OR ------
    
        1. Go to https://user.reaidy.io/.
        2. Navigate to the Activities section.
        3. Select the ${candidate?.jobRole} you applied for.
        4. Start your Assessment(s).

  Please make sure to begin the assessment(s) by ${new Date().toLocaleDateString()} to continue being considered for the position.

  If you need any assistance or have questions, feel free to reach out to us at ${
    user?.mail
  } or contact us at ${user?.mobile}.

  We appreciate your interest in joining ${
    user?.companyName ? user?.companyName : "[Company Name]"
  } and look forward to seeing your completed assessment(s).

  Best regards,

  ${user?.name}
  ${user?.designation ? user?.designation : "[Your Designation]"}
  ${user?.companyName}
  `;
  }

  const targetTime =
    new Date(candidate?.createdAt).getTime() + 72 * 60 * 60 * 1000; // 20 hours in milliseconds
  const interval = setInterval(() => {
    const now = new Date().getTime();
    const distance = targetTime - now;

    // When the count down is over, write some text
    if (distance < 0) {
      clearInterval(interval);
      setTimer("EXPIRED");
    } else {
      // Time calculations for hours, minutes and seconds
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 72)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update the timer state
      setTimer(hours + "h " + minutes + "m " + seconds + "s ");
    }
  }, 1000);
  const navigateToInterview = (interviewId, applicantId) => {
    localStorage.setItem("location", window.location.pathname);
    const baseUrl = getDomainForWhiteLabeling();
    const url = `https://${baseUrl.replace("https://", "")}/interview-invitation?meetingid=${interviewId}&applicationId=${applicantId}`;

    return url;
    // window.location.href = url;
  };
  const navigateToMockTest = (invitationId, applicantId) => {
    // alert("hello");
    const recruiterId = JSON.parse(localStorage.getItem("user"))._id;
    const baseUrl = getDomainForWhiteLabeling();
    const url =
      baseUrl === "app.reaidy.io"
        ? `https://user.reaidy.io/mcq-test/${invitationId}`
        : `https://${baseUrl.replace("https://", "")}/dashboard/mocktest?mocktestId=${invitationId}&applicationId=${applicantId}&recruiterId=${recruiterId}`;
    return url;
    // window.location.href = url;
  };

  const getOptionsForRemainder = () => {
    const opt = [];
    if (
      RecuiterStore.jobPostApplicant?.jobPostId?.mockTest !== null &&
      RecuiterStore.jobPostApplicant?.jobPostId?.mockTest &&
      !RecuiterStore.jobPostApplicant?.mockTest
    ) {
      opt.push({
        name: "MCQ",
        link: navigateToMockTest(
          RecuiterStore.jobPostApplicant?.jobPostId?.mockTest?._id,
          RecuiterStore.jobPostApplicant?._id,
        ),
      });
    }
    if (
      RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview !== null ||
      (RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview &&
        !RecuiterStore.jobPostApplicant?.technicalInterview?.isCompleted)
    ) {
      opt.push({
        name: "Technical Interview",
        link: navigateToInterview(
          RecuiterStore.jobPostApplicant?.jobPostId?.technicalInterview,
          RecuiterStore.jobPostApplicant?._id,
        ),
      });
    }
    if (
      RecuiterStore.jobPostApplicant?.jobPostId.hrInterview !== null ||
      (RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview &&
        !RecuiterStore.jobPostApplicant?.hrInterview?.isCompleted)
    ) {
      opt.push({
        name: "HR Interview",
        link: navigateToInterview(
          RecuiterStore.jobPostApplicant?.jobPostId?.hrInterview,
          RecuiterStore.jobPostApplicant?._id,
        ),
      });
    }
    return opt;
  };

  return useObserver(() => (
    <div className="w-full">
      <div className="hidden md:block lg:block">
        {isJobPost && (
          <ReportTracker
            candidate={candidate}
            enable={enable}
            reportData={reportData}
            steps={getSteps()}
            timer={timer}
            message1={message1}
            subject1={subject1}
            setMail={setMail}
            setSub={setSub}
            setContent={setContent}
          />
        )}
      </div>

      <div className="p-3  w-[98%] mx-auto rounded-t-lg  bg-[#FFEBDD] ">
        <div className="md:hidden">
          {isJobPost && (
            <ReportTracker
              candidate={candidate}
              enable={enable}
              reportData={reportData}
              steps={getSteps()}
              timer={timer}
              subject1={subject1}
              message1={message1}
              setMail={setMail}
              setSub={setSub}
              setContent={setContent}
            />
          )}
        </div>

        <div className="md:px-6 md:pt-2 flex flex-row justify-between items-center">
          <h2 className="text-[#FF6B00] font-medium mt-1">
            Report{" "}
            <span className="text-xs text-[#A4A4A4] font-normal ">
              ( Id : {candidate.id} )
            </span>
          </h2>
          <div className="md:block lg:block hidden">
            <span className="flex items-center gap-2">
              {/* <span
            className="cursor-pointer p-3 w-10 h-10 bg-green-500 hover:opacity-100 opacity-75 text-white rounded-lg "
            onClick={() => {
              setMail(true);
              setSub(subject);
              setContent(message);
              PopupStore.setMail(true);
            }}
          >
            <MdOutlineMail />
          </span> */}
              {/* <p className="text-[#A4A4A4] text-sm">{candidate?.date}</p> */}

              <p className="font-medium">Status :</p>
              {enable ? (
                <HireDropDown1
                  main={candidate?.status}
                  interview={!isJobPost}
                  handleProxy={() => {
                    ProxyCandidate(true);
                    setProxyDialogOpen(true);
                  }}
                  handleHire={() => {
                    HireCandidate(true);
                    setSub(Hiredsubject);
                    setContent(Hiredmessage);
                    PopupStore.setMail(true);
                  }}
                  handleHold={() => {
                    HOLDCandidate(false);
                    setSub(
                      getSub(mails["on_hold"].subject, {
                        _Position_: candidate?.jobRole,
                        _Company_Name_: JSON.parse(localStorage.getItem("user"))
                          ?.companyName,
                        _recruiter_email_: JSON.parse(
                          localStorage.getItem("user"),
                        )?.mail,
                        _contact_number_: JSON.parse(
                          localStorage.getItem("user"),
                        )?.mobile,
                        _Name_: JSON.parse(localStorage.getItem("user"))?.name,

                        _deadline_date_: Date.now(),
                      }),
                    );

                    setContent(
                      getSub(mails["on_hold"].body, {
                        _Position_: candidate?.jobRole,
                        _Company_Name_: JSON.parse(localStorage.getItem("user"))
                          ?.companyName,
                        _recruiter_email_: JSON.parse(
                          localStorage.getItem("user"),
                        )?.mail,
                        _contact_number_: JSON.parse(
                          localStorage.getItem("user"),
                        )?.mobile,
                        _Name_: JSON.parse(localStorage.getItem("user"))?.name,

                        _deadline_date_: Date.now(),
                      }),
                    );

                    PopupStore.setMail(true);
                  }}
                  handleReject={() => {
                    updateCandidateStatus(false);
                    setSub(Rejectsubject);
                    setContent(Rejectmessage);
                    PopupStore.setMail(true);
                  }}
                  handleShortlist={() => {
                    updateCandidateStatus(true);
                    setSub(subject);
                    setContent(message);
                    PopupStore.setMail(true);
                  }}
                  padding={3}
                  className="text-xs"
                />
              ) : (
                <span className="text-xs text-primary font-semibold">
                  {RecuiterStore.jobPostApplicant?.status === 3 ? (
                    <span className="text-[#20BF55] text-base font-semibold flex items-center gap-1 ">
                      Hired
                      <div className="relative group">
                        <MdInfoOutline className="text-gray-500 text-base" />
                        <div className="absolute -bottom-3 z-50 transform right-4 mb-2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                          This candidate has been selected and successfully
                          hired.
                        </div>
                      </div>
                    </span>
                  ) : RecuiterStore.jobPostApplicant?.status === 1 ? (
                    <span className="text-orange-400 text-base font-semibold  flex items-center gap-1">
                      Shortlisted
                      <div className="relative group">
                        <MdInfoOutline className="text-gray-500 text-base flex items-center gap-1" />
                        <div className="absolute bottom-3 z-50 transform right-4 mb-2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                          This candidate is under consideration for the next
                          stage.
                        </div>
                      </div>
                    </span>
                  ) : RecuiterStore.jobPostApplicant?.status === 2 ? (
                    <span className="text-red-500 text-base font-semibold flex items-center gap-1 ">
                      Rejected
                      <div className="relative group">
                        <MdInfoOutline className="text-gray-500 text-base" />
                        <div className="absolute bottom-3 z-50 transform right-4 mb-2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                          This candidate was not selected for the role.
                        </div>
                      </div>
                    </span>
                  ) : (
                    <span className="text-primary text-base font-semibold  flex items-center gap-1">
                      Pending
                      <div className="relative group">
                        <MdInfoOutline className="text-gray-500 text-base" />
                        <div className="absolute bottom-3 z-50 transform right-4 mb-2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                          The application is still under review, and a decision
                          has not yet been made.
                        </div>
                      </div>
                    </span>
                  )}
                </span>
              )}
            </span>
          </div>
        </div>
        <Remainder
          options={getOptionsForRemainder()}
          onSent={() => {
            const mess = generateAssessmentMessage(
              RecuiterStore.RemaindedAssessment,
            );
            setContent(mess);
            PopupStore.setMail2(true);
          }}
        />
        <ProxyReasonDialog
          isOpen={proxyDialogOpen}
          onClose={() => setProxyDialogOpen(false)}
          onSelectReason={handleProxyReasonSelect}
          candidate={candidate}
        />
        <MailPopup
          jobRole={candidate?.jobRole}
          id={candidate?._id}
          interview={!isJobPost}
          onSent={async () => {
            // PopupStore.setMail(false);
            {
              !isJobPost
                ? InterviewStore.handleStatusChange(
                    candidate._id,
                    statusNumber === 1
                      ? "shortlisted"
                      : statusNumber === 2
                        ? "rejected"
                        : statusNumber === 3
                          ? "hired"
                          : statusNumber === 4
                            ? "proxy"
                            : "hold",
                  )
                : await RecuiterStore.ChangeApplicantStatus(
                    statusNumber === 1
                      ? "shortlisted"
                      : statusNumber === 2
                        ? "rejected"
                        : statusNumber === 3
                          ? "hired"
                          : statusNumber === 4
                            ? "proxy"
                            : "hold",
                    statusNumber,
                  );
              // await RecuiterStore.fetchJobPostApplications(id);
              await RecuiterStore.fetchApplicantDetails(candidate?.id);
            }

            PopupStore.setMail(false);
          }}
          emails={[candidate?.email]}
          report={mail ? false : true}
          sub={sub}
          mess={content}
          status={status}
          statusCondition={statusCondition}
          statusNumber={statusNumber}
          proxyReasons={selectedProxyReasons}
          candidate={candidate}
        />
        <Loader loader={loader || RecuiterStore.loader} />
        <div className=" flex items-start w-[95%] md:mx-auto justify-between mt-4">
          <div className="flex md:flex-row flex-col items-start md:items-center w-full justify-start md:justify-between">
            <div className="flex items-center md:w-[70%] md:mr-5 justify-start">
              <img
                style={{
                  backgroundImage: `url(${constantVariables.defaultProfilePic})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                src={
                  candidate.image
                    ? candidate.image
                    : constantVariables.defaultProfilePic
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = constantVariables.defaultProfilePic;
                }}
                alt={candidate.name}
                className="md:w-24 md:h-24 w-[60px] h-[52px] rounded-full border border-primary md:mt-0 lg:mt-0 md:mr-5 mr-5"
              />
              <div className="w-full">
                <div className="flex items-center justify-between">
                  <h2
                    className="text-lg flex items-center font-bold"
                    onClick={() => {
                      console.log(candidate);
                    }}
                  >
                    {accessTypeStatus === "restricted"
                      ? candidate?.name?.slice(0, 15) + "..."
                      : candidate?.name || "-"}
                    <ApplicantLabelPopup />{" "}
                  </h2>
                  {/* <h2> */}
                  <div className="cursor-pointer  flex items-center whitespace-nowrap md:block hidden gap-2">
                    {/* <span> */}
                    {RecuiterStore.jobPostApplicant?.labels ? (
                      <div className="flex items-center gap-2">
                        {RecuiterStore.jobPostApplicant?.labels[0] ? (
                          <>
                            <div className="flex items-center gap-2 hidden md:flex lg:flex">
                              <span
                                className="cursor-pointer border border-primary p-1 bg-white  text-black rounded-md "
                                onClick={() => {
                                  setMail(true);
                                  setSub(subject1);
                                  setContent(message1);
                                  PopupStore.setMail(true);
                                }}
                              >
                                <MdOutlineMail />
                              </span>
                            </div>
                            {/* <span>Tags : </span> */}
                            <MdBookmarkBorder
                              className={`  text-2xl border border-primary p-1 bg-white  text-primary rounded-md ${
                                !enable
                                  ? "cursor-not-allowed"
                                  : "cursor-pointer"
                              }`}
                              onClick={() => {
                                if (enable) {
                                  LabelStore.setsection("application");
                                  console.log(
                                    RecuiterStore.jobPostApplicant.labels,
                                  );
                                  console.log(LabelStore.section);
                                  LabelStore.setApplicantLabelArray(
                                    RecuiterStore.jobPostApplicant.labels,
                                  );
                                  LabelStore.setApplicantId(
                                    RecuiterStore.jobPostApplicant._id,
                                  );
                                  LabelStore.setApplicants(true);
                                }
                              }}
                            />
                            {/* <div>
                              <p className="bg-blue-500 h-5 w-5 rounded-full "></p>
                            </div> */}
                          </>
                        ) : (
                          <>
                            <div className="flex items-center gap-2 hidden md:flex lg:flex">
                              <span
                                className="cursor-pointer border border-primary p-1 bg-white text-black rounded-md "
                                onClick={() => {
                                  setMail(true);
                                  setSub(subject1);
                                  setContent(message1);
                                  PopupStore.setMail(true);
                                }}
                              >
                                <MdOutlineMail />
                              </span>
                            </div>
                            {/* <span>Tags : </span> */}

                            <MdBookmarkBorder
                              onClick={() => {
                                if (enable) {
                                  LabelStore.setsection("application");
                                  console.log(
                                    RecuiterStore.jobPostApplicant.labels,
                                  );
                                  console.log(LabelStore.section);
                                  LabelStore.setApplicantLabelArray(
                                    RecuiterStore.jobPostApplicant.labels,
                                  );
                                  LabelStore.setApplicantId(
                                    RecuiterStore.jobPostApplicant._id,
                                  );
                                  console.log(
                                    LabelStore.ApplicantId,
                                    "applicantId",
                                  );
                                  LabelStore.setApplicants(true);
                                }
                              }}
                              className={`  text-2xl border border-primary p-1 bg-white rounded-md ${
                                !enable
                                  ? "cursor-not-allowed"
                                  : "cursor-pointer"
                              }`}
                            />
                            {/* <div
                              className="flex"
                              onClick={() => {
                                LabelStore.setsection("application");
                                console.log(
                                  RecuiterStore.jobPostApplicant.labels
                                );
                                console.log(LabelStore.section);
                                LabelStore.setApplicantLabelArray(
                                  RecuiterStore.jobPostApplicant.labels
                                );
                                LabelStore.setApplicantId(
                                  RecuiterStore.jobPostApplicant._id
                                );
                                LabelStore.setApplicants(true);
                              }}
                            >
                              <p className="bg-blue-500 h-5 w-5 rounded-full -ml-3 "></p>
                              <p className="bg-red-500 h-5 w-5 rounded-full -ml-3 "></p>
                              <p className="bg-blue-500 h-5 w-5 rounded-full -ml-3 "></p>
                              <p className="bg-red-500 h-5 w-5 rounded-full -ml-3 "></p>
                              <p className="bg-blue-500 h-5 w-5 rounded-full -ml-3 "></p>
                              <p className="bg-red-500 h-5 w-5 rounded-full -ml-3 "></p>
                            </div> */}
                          </>
                        )}
                      </div>
                    ) : null}
                    {/* </span> */}
                  </div>
                  {/* </h2> */}
                </div>

                {/*{" "}
                    {RecuiterStore.jobPostApplicant?.isHired && (
                      <span className="text-[#20BF55] text-base font-semibold ">
                      Hired
                      </span>
                    )}
                    {RecuiterStore.jobPostApplicant?.isShortlisted && (
                      <span className="text-orange-400 text-base font-semibold ">
                      Shortlisted
                      </span>
                    )}
                    {RecuiterStore.jobPostApplicant?.isRejected && (
                      <span className="text-red-500 text-base font-semibold ">
                      Rejected
                      </span>
                    )}{" "}
                    */}
                <div className="flex md:flex-row lg:flex-row flex-row md:items-center lg:items-center items-start md:gap-4 lg:gap-4 gap-2">
                  <div className="md:flex gap-2">
                    <div className="flex md:text-base lg:text-base text-sm items-center text-[#A4A4A4] mt-2">
                      <MdOutlineLocationOn className="mr-1" />
                      <span>{candidate?.location}</span>
                    </div>
                    <div className="flex md:text-base lg:text-base text-sm items-center text-[#A4A4A4] mt-2">
                      <MdOutlinePhone className="mr-1" />
                      <span>
                        {accessTypeStatus === "restricted"
                          ? "*********"
                          : candidate?.mobile || "-"}
                      </span>
                    </div>
                  </div>
                  <div className="md:flex gap-2">
                    <div className="flex md:text-base lg:text-base text-sm items-center text-[#A4A4A4] mt-2 whitespace-nowrap">
                      <MdOutlineDateRange className="mr-1" />
                      <span>{candidate?.date}</span>
                    </div>
                    <div className="flex md:text-base lg:text-base text-sm items-center text-[#A4A4A4] mt-2">
                      <MdOutlineMail className="mr-1" />
                      <span className="relative group">
                        {accessTypeStatus === "restricted"
                          ? candidate?.email?.slice(0, 9) + "..."
                          : candidate?.email?.substring(0, 9) + "..."}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap md:space-x-2 mt-2 items-center hidden md:block lg:block">
                  {candidate?.skills
                    ?.slice(0, skillsCount)
                    .map((skill, index) => (
                      <React.Fragment key={index}>
                        {index % 4 === 0 && index !== 0 && (
                          <div className="w-full"></div>
                        )}
                        <span className="text-primary bg-white  px-4 py-1 rounded-full text-xs gil-med whitespace-nowrap">
                          {skill}
                        </span>
                      </React.Fragment>
                    ))}
                  {candidate?.skills?.length > 0 &&
                    (skillsCount < candidate.skills.length ? (
                      <span
                        onClick={() =>
                          setSkillsCount(
                            candidate.skills ? candidate.skills.length : 0,
                          )
                        }
                        className="text-primary cursor-pointer text-xs underline font-semibold"
                      >
                        {"+"}
                        {candidate.skills
                          ? candidate.skills.length - skillsCount
                          : 0}{" "}
                        {" more"}
                      </span>
                    ) : (
                      candidate.skills.length > 4 && (
                        <span
                          onClick={() => setSkillsCount(4)}
                          className="text-primary cursor-pointer text-xs underline font-semibold"
                        >
                          view{" less"}
                        </span>
                      )
                    ))}
                </div>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center gap-2">
                    <button
                      className={`flex flex-row whitespace-nowrap items-center justify-center gap-1 font-medium text-[#FF6B00] h-8 rounded-lg text-sm ${accessTypeStatus === "restricted" ? "cursor-not-allowed" : ""}`}
                      onClick={() => {
                        CommonStore.setJobResume(candidate.resumelink);
                        CommonStore.setResume(true);
                        RecuiterStore.setAllowError(true);
                      }}
                      disabled={accessTypeStatus === "restricted"}
                    >
                      <span>
                        <AiOutlineFileText
                          className="font-medium
                "
                          disabled={accessTypeStatus === "restricted"}
                        />
                        {}
                      </span>
                      View Resume
                    </button>

                    {isJobPost && (
                      <>
                        <p className="text-green-500 font-medium">
                          {candidate?.resumeScore
                            ? candidate?.resumeScore + "% Matched"
                            : null}
                        </p>
                        {!candidate?.resumeScore ? (
                          <>
                            {"- - %"}
                            <p
                              className="cursor-pointer text-primary underline text-sm"
                              onClick={() => {
                                setLoader(true);
                                GenerateResumeScore(candidate?.resume);
                              }}
                            >
                              Get Score
                            </p>
                          </>
                        ) : null}
                      </>
                    )}
                  </div>
                  {/* <div className="flex items-center gap-2 hidden md:flex lg:flex">
                    <span
                      className="cursor-pointer border border-primary p-1 bg-white hover:opacity-100 opacity-75 text-black rounded-md "
                      onClick={() => {
                        setMail(true);
                        setSub(subject);
                        setContent(message);
                        PopupStore.setMail(true);
                      }}
                    >
                      <MdOutlineMail />
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
            {candidate?.skills?.length > 0 ? (
              <>
                <div className="md:hidden block">
                  <h3 className="font-semibold ml-1">Skills</h3>
                </div>

                <div className="flex flex-wrap gap-2 mt-2 items-center justify-start block md:hidden lg:hidden">
                  {candidate?.skills
                    ?.slice(0, skillsCount)
                    .map((skill, index) => (
                      <React.Fragment key={index}>
                        {index % 4 === 0 && index !== 0 && (
                          <div className="w-full"></div>
                        )}
                        <span className="text-primary bg-white px-2 py-1 rounded-full text-xs font-semibold">
                          {skill}
                        </span>
                      </React.Fragment>
                    ))}

                  {skillsCount < candidate.skills.length ? (
                    <span
                      onClick={() => setSkillsCount(candidate.skills.length)}
                      className="text-primary cursor-pointer text-xs underline font-semibold"
                    >
                      {"+"}
                      {candidate.skills.length - skillsCount} {" more"}
                    </span>
                  ) : (
                    candidate.skills.length > 4 && (
                      <span
                        onClick={() => setSkillsCount(4)}
                        className="text-primary cursor-pointer text-xs underline font-semibold"
                      >
                        view{" less"}
                      </span>
                    )
                  )}
                </div>
              </>
            ) : (
              <span className="text-gray-500 text-xs font-semibold md:hidden lg:hidden">
                No skills
              </span>
            )}

            <div className="md:hidden block -mb-3 mt-2">
              <h3 className="font-semibold">Score</h3>
            </div>
            <div className="flex items-center gap-4 md:w-[30%] w-full md:justify-end  md:pl-3 py-2 md:border-l-2 md:border-dashed md:border-[#BEBEBE] ">
              <div className="flex flex-row md:flex-col  md:gap-2 gap-5 ">
                {/* <h3 className=" font-semibold">
                Job role -{" "}
                <span
                  className={`${
                    candidate.communication === "Pending"
                      ? "text-primary"
                      : "text-[#20BF55]"
                  }`}
                >
                  {candidate?.jobRole}
                </span>
              </h3> */}

                <p className=" mt-2 flex flex-col">
                  <span
                    className={`${
                      candidate.communication === "Pending"
                        ? "text-primary"
                        : "text-primary"
                    }`}
                  >
                    {candidate.communication === "Pending" ||
                    !candidate.communication
                      ? "Pending"
                      : candidate.communication + "%"}
                  </span>
                  <span className="text-xs md:text-sm">Communication </span>
                </p>
                <p className=" mt-2 flex flex-col">
                  <span
                    className={`${
                      candidate?.communication === "Pending"
                        ? "text-primary"
                        : "text-primary"
                    }`}
                  >
                    {candidate.technicalSkills === "Pending" ||
                    !candidate.technicalSkills
                      ? "Pending"
                      : candidate.technicalSkills + "%"}
                  </span>
                  <span className="text-xs md:text-sm md:whitespace-normal whitespace-nowrap">
                    Technical skills{" "}
                  </span>
                </p>
                <p className=" mt-2 flex flex-col">
                  <span
                    className={`${
                      candidate?.communication === "Pending"
                        ? "text-primary"
                        : "text-primary"
                    }`}
                  >
                    {candidate.hrScore === "Pending" || !candidate.hrScore
                      ? "Pending"
                      : candidate.hrScore + "%"}
                  </span>
                  <span className="text-xs md:text-sm md:whitespace-normal whitespace-nowrap">
                    HR score{" "}
                  </span>
                </p>

                {/* <p className=" mt-2 flex flex-col">
                  <span
                    className={`  ${
                      candidate.overallScore === "Pending"
                        ? "text-sm"
                        : "text-base"
                    }`}
                  >
                    {candidate.overallScore === "Pending"
                      ? "Pending"
                      : (!isNaN(parseFloat(candidate.overallScore))
                          ? parseFloat(candidate.overallScore).toFixed(0)
                          : 0) + "%"}
                  </span>
                  <span className="text-xs md:text-sm">overallScore </span>
                </p> */}

                <p className="cursor-pointer flex flex-col items-center md:hidden  mt-[10px] ml-6 ">
                  {RecuiterStore.jobPostApplicant?.labels ? (
                    <div className="flex ">
                      {RecuiterStore.jobPostApplicant?.labels[0] ? (
                        <MdBookmarkBorder
                          className={`  text-2xl border border-primary p-1 bg-white  text-primary rounded-md ${
                            !enable ? "cursor-not-allowed" : "cursor-pointer"
                          }`}
                          onClick={() => {
                            if (enable) {
                              LabelStore.setsection("application");
                              console.log(
                                RecuiterStore.jobPostApplicant.labels,
                              );
                              console.log(LabelStore.section);
                              LabelStore.setApplicantLabelArray(
                                RecuiterStore.jobPostApplicant.labels,
                              );
                              LabelStore.setApplicantId(
                                RecuiterStore.jobPostApplicant._id,
                              );
                              LabelStore.setApplicants(true);
                            }
                          }}
                        />
                      ) : (
                        <MdBookmarkBorder
                          onClick={() => {
                            if (enable) {
                              LabelStore.setsection("application");
                              console.log(
                                RecuiterStore.jobPostApplicant.labels,
                              );
                              console.log(LabelStore.section);
                              LabelStore.setApplicantLabelArray(
                                RecuiterStore.jobPostApplicant.labels,
                              );
                              LabelStore.setApplicantId(
                                RecuiterStore.jobPostApplicant._id,
                              );
                              LabelStore.setApplicants(true);
                            }
                          }}
                          className={`  text-2xl border border-primary p-1 bg-white rounded-md `}
                        />
                      )}
                    </div>
                  ) : null}
                  <p className="text-xs">Tags</p>
                </p>
                <div className="flex flex-col pb-1 items-center mt-[10px] block md:hidden lg:hidden">
                  <span
                    className="cursor-pointer border border-primary p-1 bg-white hover:opacity-100 opacity-75 text-black rounded-md "
                    onClick={() => {
                      setMail(true);
                      setSub(subject);
                      setContent(message);
                      PopupStore.setMail(true);
                    }}
                  >
                    <MdOutlineMail className="text-sm" />
                  </span>
                  <p className="text-xs">mail</p>
                </div>
              </div>
              <div className="text-center ml-5 hidden md:block">
                <div className="relative w-24 h-24 mx-auto">
                  <svg
                    className="absolute top-0 left-0 w-full h-full"
                    viewBox="0 0 100 100"
                  >
                    <circle
                      cx="50"
                      cy="50"
                      r="45"
                      className="stroke-current text-gray-200"
                      strokeWidth="10"
                      fill="none"
                    />
                    <circle
                      cx="50"
                      cy="50"
                      r="45"
                      className="stroke-current text-primary"
                      strokeWidth="10"
                      fill="none"
                      strokeDasharray="282.6"
                      strokeDashoffset={
                        candidate.overallScore === "Pending"
                          ? 282.6 // If overallScore is "Pending", treat as 0% (full circle)
                          : 282.6 -
                            (282.6 *
                              (candidate.overallScore === "Pending"
                                ? 0
                                : candidate.overallScore)) /
                              100
                      }
                      strokeLinecap="round"
                      transform="rotate(-90, 50, 50)"
                    />
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center text-primary">
                    <span
                      className={` font-semibold ${
                        candidate.overallScore === "Pending"
                          ? "text-sm"
                          : "text-lg"
                      }`}
                    >
                      {candidate.overallScore === "Pending"
                        ? "Pending"
                        : (!isNaN(parseFloat(candidate.overallScore))
                            ? parseFloat(candidate.overallScore).toFixed(0)
                            : 0) + "%"}
                    </span>
                  </div>
                </div>
                <p className="mt-2 font-semibold whitespace-nowrap text-sm  ">
                  Overall score
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col ">
            {/* <CandidateButtons
            fromMainPage={true}
            id={recruiter?._id}
            handleReject={() => {
              updateCandidateStatus(false)
              setSub(Rejectsubject);
              setContent(Rejectmessage);
              PopupStore.setMail(true);
            }}
            handleShortlist={() => {
              updateCandidateStatus(true)
              setSub(subject);
              setContent(message);
              PopupStore.setMail(true);
            }}
          /> */}
          </div>
        </div>
        {/* <CandidateButtons
        ismobile={true}
        handleReject={() => updateCandidateStatus(false)}
        handleShortlist={() => updateCandidateStatus(true)}
      /> */}
        <CandidateButtons
          ismobile={true}
          fromMainPage={true}
          id={recruiter?._id}
          handleReject={() => {
            updateCandidateStatus(false);
            setSub(Rejectsubject);
            setContent(Rejectmessage);
            PopupStore.setMail(true);
          }}
          handleShortlist={() => {
            updateCandidateStatus(true);
            setSub(subject);
            setContent(message);
            PopupStore.setMail(true);
          }}
        />
        <div className="mt-4 w-[90%] mx-auto flex md:flex-row lg:flex-row flex-col items-center gap-6 ">
          {/* <div className="flex items-center md:w-[40%] lg:w-[40%] w-full justify-between pl-0 p-2 pr-[3%] md:border-r lg:border-r md:border-[#838383] lg:border-[#838383] ">
          <div>
            <h3 className=" font-semibold">
              Job role -{" "}
              <span
                className={`${
                  candidate.communication === "Pending"
                    ? "text-primary"
                    : "text-[#20BF55]"
                }`}
              >
                {candidate?.jobRole}
              </span>
            </h3>
            <p className=" mt-2">
              Technical skills -{" "}
              <span
                className={`${
                  candidate?.communication === "Pending"
                    ? "text-primary"
                    : "text-[#20BF55]"
                }`}
              >
                {candidate.technicalSkills === "Pending"
                  ? "Pending"
                  : candidate.technicalSkills + "%"}
              </span>
            </p>
            <p className=" mt-2">
              Communication -{" "}
              <span
                className={`${
                  candidate.communication === "Pending"
                    ? "text-primary"
                    : "text-[#20BF55]"
                }`}
              >
                {candidate.communication === "Pending"
                  ? "Pending"
                  : candidate.communication + "%"}
              </span>
            </p>
          </div>
          <div className="text-center">
            <div className="relative w-24 h-24 mx-auto">
              <svg
                className="absolute top-0 left-0 w-full h-full"
                viewBox="0 0 100 100"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  className="stroke-current text-gray-200"
                  strokeWidth="10"
                  fill="none"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  className="stroke-current text-[#20BF55]"
                  strokeWidth="10"
                  fill="none"
                  strokeDasharray="282.6"
                  strokeDashoffset={
                    candidate.overallScore === "Pending"
                      ? 282.6 // If overallScore is "Pending", treat as 0% (full circle)
                      : 282.6 -
                        (282.6 *
                          (candidate.overallScore === "Pending"
                            ? 0
                            : candidate.overallScore)) /
                          100
                  }
                  strokeLinecap="round"
                  transform="rotate(-90, 50, 50)"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <span
                  className={` font-semibold ${
                    candidate.overallScore === "Pending" ? "text-md" : "text-xl"
                  }`}
                >
                  {candidate.overallScore === "Pending"
                    ? "Pending"
                    : (!isNaN(parseFloat(candidate.overallScore))
                        ? parseFloat(candidate.overallScore).toFixed(0)
                        : 0) + "%"}
                </span>
              </div>
            </div>
            <p className="text-gray-700 mt-2">Overall score</p>
          </div>
        </div> */}
          {/* <div className="md:w-[25%] lg:w-[25%] w-full mx-auto p-2 pl-0 py-4 pr-[5%] md:border-r lg:border-r md:border-[#838383] lg:border-[#838383]">
          <div className="text-center">
            <div className="relative w-24 h-24 mx-auto">
              <svg
                className="absolute top-0 left-0 w-full h-full"
                viewBox="0 0 100 100"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  className="stroke-current text-gray-200"
                  strokeWidth="10"
                  fill="none"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  className="stroke-current text-[#20BF55]"
                  strokeWidth="10"
                  fill="none"
                  strokeDasharray="282.6"
                  strokeDashoffset={
                    282.6 * (1 - (candidate.resumeScore || 0) / 100)
                  }
                  strokeLinecap="round"
                  transform="rotate(-90, 50, 50)"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <span
                  className={` ${
                    candidate?.resumeScore ? "text-base" : "text-xs"
                  } truncate w-16 font-semibold ${
                    candidate.overallScore === "Pending" ? "text-md" : "text-xl"
                  }`}
                >
                  {candidate?.resumeScore
                    ? candidate?.resumeScore + "%"
                    : "Not Generated"}
                </span>
              </div>
            </div>
            {!candidate?.resumeScore ? (
              <p
                className="cursor-pointer mt-2 bg-yellow-300 py-2 px-5 rounded-xl w-fit text-white font-semibold mx-auto"
                onClick={() => {
                  setLoader(true);
                  GenerateResumeScore();
                }}
              >
                Generate Score
              </p>
            ) : null}
          </div>
          <h3 className="text-base text-center font-semibold mt-2">
            JD Resume Match
          </h3>
        </div> */}

          {/* <div className="md:w-[25%] lg:w-[25%] w-full mx-auto p-2 pl-0 py-4 pr-[5%] md:border-r lg:border-r md:border-[#838383] lg:border-[#838383]">
          <h3 className="text-base font-semibold">Assessment Status</h3>
          {/* <div className="flex items-center justify-between text-[#838383] mt-2">
            <span>MCQ test</span>
            {candidate.mcq.status ? (
              <MdOutlineCheckCircleOutline className=" text-xl text-[#20BF55]" />
            ) : (
              <AiOutlineCloseCircle className=" text-xl text-[#838383]]" />
            )}
          </div> */}
          {/* {candidate?.jobPost?.mockTest !== null && (
            <div className="flex items-center justify-between text-[#838383] mt-2">
              <span>MCQ test</span>
              {candidate?.mcq?.status ? (
                <p className="flex gap-2">
                  <MdOutlineCheckCircleOutline className=" text-xl text-[#20BF55]" />
                  <span
                    className={`${
                      candidate.mcq.score === "Pending" ||
                      candidate.mcq.score === "No result"
                        ? "text-text_warningColor"
                        : "text-[#20BF55]"
                    }`}
                  >
                    {!isNaN(parseFloat(candidate.mcq.score)) ? parseFloat(candidate.mcq.score).toFixed(0) : 0}
                    {candidate.mcq.score === "Pending" ||
                    candidate.mcq.score === "No result"
                      ? ""
                      : "%"}
                  </span>
                </p>
              ) : (
                <p className="flex">
                  <AiOutlineCloseCircle className=" text-xl text-[#838383]" />{" "}
                  <span
                    className={`${
                      candidate.mcq.score === "Pending" ||
                      candidate.mcq.score === "No result"
                        ? "text-text_warningColor"
                        : "text-[#20BF55]"
                    }`}
                  >
                    {candidate.mcq.score}
                    {candidate.mcq.score === "Pending" ||
                    candidate.mcq.score === "No result"
                      ? ""
                      : "%"}
                  </span>
                </p>
              )}
            </div>
          )}
          {candidate.jobPost?.technicalInterview !== null && (
            <div className="flex items-center justify-between text-[#838383] mt-2">
              <span>Technical interview</span>
              {candidate.technical.status ? (
                <p className="flex gap-2">
                  <MdOutlineCheckCircleOutline className=" text-xl text-[#20BF55]" />{" "}
                  <span
                    className={`${
                      candidate.technical.score === "Pending" ||
                      candidate.technical.score === "No result"
                        ? "text-text_warningColor"
                        : "text-[#20BF55]"
                    }`}
                  >
                    {candidate.technical.score}
                    {candidate.technical.score === "Pending" ||
                    candidate.technical.score === "No result"
                      ? ""
                      : "%"}
                  </span>
                </p>
              ) : (
                <p className="flex gap-2">
                  <AiOutlineCloseCircle className=" text-xl text-[#838383]" />{" "}
                  <span
                    className={`${
                      candidate.technical.score === "Pending" ||
                      candidate.technical.score === "No result"
                        ? "text-text_warningColor"
                        : "text-[#20BF55]"
                    }`}
                  >
                    {candidate.technical.score}
                    {candidate.technical.score === "Pending" ||
                    candidate.technical.score === "No result"
                      ? ""
                      : "%"}
                  </span>
                </p>
              )}
            </div>
          )}
          {candidate.jobPost?.hrInterview !== null && (
            <div className="flex  items-center justify-between text-[#838383] mt-2">
              <span>HR interview</span>
              {candidate.hr.status ? (
                <p className="flex gap-2">
                  <MdOutlineCheckCircleOutline className=" text-xl text-[#20BF55]" />{" "}
                  <span
                    className={`${
                      candidate.hr.score === "Pending" ||
                      candidate.hr.score === "No result"
                        ? "text-text_warningColor"
                        : "text-[#20BF55]"
                    }`}
                  >
                    {candidate.hr.score}{" "}
                    {candidate.hr.score === "Pending" ||
                    candidate.hr.score === "No result"
                      ? ""
                      : "%"}
                  </span>
                </p>
              ) : (
                <p className="flex gap-2">
                  <AiOutlineCloseCircle className=" text-xl text-[#838383]]" />
                  <span
                    className={`${
                      candidate.hr.score === "Pending" ||
                      candidate.hr.score === "No result"
                        ? "text-text_warningColor"
                        : "text-[#20BF55]"
                    }`}
                  >
                    {candidate.hr.score}{" "}
                    {candidate.hr.score === "Pending" ||
                    candidate.hr.score === "No result"
                      ? ""
                      : "%"}
                  </span>
                </p>
              )}
            </div>
          )}
        </div> */}
          {/* <div className="p-2 md:w-[25%] lg:w-[25%] w-full mx-auto ">
          <h3 className="text-base font-semibold">Scores</h3>
          {candidate?.jobPost?.mockTest !== null && (
            <div className="flex items-center justify-between text-[#838383] mt-2">
              <span className="mr-2">MCQ test</span>
              <span
                className={`${
                  candidate.mcq.score === "Pending" ||
                  candidate.mcq.score === "No result"
                    ? "text-text_warningColor"
                    : "text-[#20BF55]"
                }`}
              >
                {candidate.mcq.score}
                {candidate.mcq.score === "Pending" ||
                candidate.mcq.score === "No result"
                  ? ""
                  : "%"}
              </span>
            </div>
          )}

          {candidate.jobPost?.technicalInterview !== null && (
            <div className="flex items-center justify-between text-[#838383] mt-2">
              <span className="mr-2">Technical interview</span>
              <span
                className={`${
                  candidate.technical.score === "Pending" ||
                  candidate.technical.score === "No result"
                    ? "text-text_warningColor"
                    : "text-[#20BF55]"
                }`}
              >
                {candidate.technical.score}
                {candidate.technical.score === "Pending" ||
                candidate.technical.score === "No result"
                  ? ""
                  : "%"}
              </span>
            </div>
          )}

          {candidate.jobPost?.hrInterview !== null && (
            <div className="flex items-center justify-between text-[#838383] mt-2">
              <span className="mr-2">HR interview</span>
              <span
                className={`${
                  candidate.hr.score === "Pending" ||
                  candidate.hr.score === "No result"
                    ? "text-text_warningColor"
                    : "text-[#20BF55]"
                }`}
              >
                {candidate.hr.score}{" "}
                {candidate.hr.score === "Pending" ||
                candidate.hr.score === "No result"
                  ? ""
                  : "%"}
              </span>
            </div>
          )}
        </div> */}
        </div>
      </div>
    </div>
  ));
}

export function ReportTracker({
  reportData,
  steps,
  timer,
  subject1,
  message1,
  candidate,
  recruiter,
  subject,
  message,
  Rejectsubject,
  Rejectmessage,
  status,
  statusCondition,
  statusNumber,
  updateCandidateStatus,
  GenerateResumeScore,
  loader,
  setLoader,
  mail,
  setMail,
  setSub,
  setContent,
  skillsCount,
  setSkillsCount,
  enable,
}) {
  const { PopupStore, InterviewStore, RecuiterStore } = useStores();
  const [rejectWhyPopup, setRejectWhyPopup] = useState(false);
  const [rejectWhy, setRejectWhy] = useState("");
  const [rejectWhyMessage, setRejectWhyMessage] = useState("");
  const [trackerWidth, setTrackerWidth] = useState("");

  const getWidthFromSteps = useCallback(() => {
    if (!steps) return "";
    const visibleSteps = steps.filter((step) => step.show).length;
    const mobileWidth = visibleSteps * 150;
    const desktopWidth = visibleSteps * 10;
    return `${mobileWidth}vw md:w-[${desktopWidth}vw]`;
  });

  useEffect(() => {
    const width = getWidthFromSteps();
    setTrackerWidth(width);
  }, [steps]);

  return (
    <div>
      <div className="hidden md:block">
        <div className="w-[98%] flex justify-between mb-5 mx-auto border border-primary rounded-lg  pt-3 pb-3 items-center bg-white !text-black pl-8 pr-5 ">
          <div className="w-[50vw] overflow-x-scroll no-scrollbar h-16 mt-4">
            <ProgressBarTracker
              steps={steps}
              commingFrom={"applicant"}
              width={trackerWidth}
              onRejectClickWhy={() => {
                PopupStore.setAlert(true);
                PopupStore.setTitle("Reason for rejection");
                PopupStore.setMessage(`
                  The Required cut off for this assessment is not met by the candidate.
                  `);
                setRejectWhyPopup(true);
              }}
            />
          </div>
          <button
            className={`rounded-lg md:rounded-xl py-2 whitespace-nowrap px-2 text-sm md:px-4 md:py-3 flex items-center gap-1  md:gap-2 text-[#FFFFFF] ${
              (reportData[3]?.show
                ? reportData[3]?.isCompleted
                : reportData[2]?.isCompleted) &&
              candidate.assessment?.isCompleted
                ? "bg-green-500 cursor-auto"
                : "bg-primary"
            }`}
            onClick={() => {
              if (
                !(reportData[3]?.show
                  ? reportData[3]?.isCompleted
                  : reportData[2]?.isCompleted)
              ) {
                RecuiterStore.RemaindedAssessment = [];
                PopupStore.setRemainder(true);
                setMail(true);
                setSub(subject1);
                // setContent(message1);
                // PopupStore.setMail(true);
              } else {
                setMail(true);
                setSub(subject1);
                setContent(message1);
                PopupStore.setMail(true);
              }
            }}
          >
            {(reportData[3]?.show
              ? reportData[3]?.isCompleted
              : reportData[2]?.isCompleted) &&
            candidate.assessment?.isCompleted ? (
              "Assessment completed"
            ) : (
              <span className="flex flex-row text-center">
                {" "}
                Remind Candidate{" "}
                <IoIosArrowDropright className="text-[#FFFFFF] text-lg" />
              </span>
            )}
          </button>
        </div>
      </div>
      <div className="w-[100%]  flex flex-col justify-between mx-auto border border-primary bg-white rounded-lg  pt-2 items-center  md:hidden  block !text-black pb-5 pr-3 ">
        <div className="w-[91%] overflow-x-scroll no-scrollbar h-20 mt-0  ">
          <ProgressBarTracker
            steps={steps}
            commingFrom={"applicant"}
            width={trackerWidth}
            onRejectClickWhy={() => {
              PopupStore.setAlert(true);
              PopupStore.setTitle("Reason for rejection");
              PopupStore.setMessage(`
                  The Required cut off for this assessment is not met by the candidate.
                  
                  `);
              setRejectWhyPopup(true);
            }}
          />
        </div>

        <div className="flex w-[91%] item-center justify-between mt-0">
          {!(reportData[3]?.show
            ? reportData[3]?.score
            : reportData[2]?.score) && (
            <div className="flex  item-center  mt-4 justify-between ml-8  ">
              {/* <div className="flex">
                <AiOutlineClockCircle className="text-xs text-primary  items-center" />
                <p className="text-[9px]">
                  {" "} */}
              {/* Time left to complete assessment{" "} */}
              {/* <span className="!text-black font-bold text-xs">{timer}</span>
                </p> */}
              {/* </div> */}
            </div>
          )}

          <div
            className={`mt-4 ${
              (
                reportData[3]?.show
                  ? reportData[3]?.score
                  : reportData[2]?.score
              )
                ? "cursor-auto justify-end ml-auto"
                : ""
            }`}
          >
            {(
              reportData[3]?.show ? reportData[3]?.score : reportData[2]?.score
            ) ? (
              "Assessment completed"
            ) : (
              <button
                className={`rounded-lg md:rounded-xl py-2 whitespace-nowrap text-[10px] px-4 flex items-center text-white bg-primary`}
                onClick={() => {
                  setMail(true);
                  setSub(subject1);
                  setContent(message1);
                  PopupStore.setMail(true);
                }}
              >
                Remind Candidate
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
